import { render, staticRenderFns } from "./SubformulaModel.vue?vue&type=template&id=3ee067e0&scoped=true"
import script from "./SubformulaModel.vue?vue&type=script&lang=js"
export * from "./SubformulaModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee067e0",
  null
  
)

export default component.exports